"use client"
import { createContext, useContext, useState } from "react"

// Création du contexte
const HoverContext = createContext();

function HoverProvider({children}){

  const [hoverTarget, setHoverTarget] = useState()

  return( 
    <HoverContext.Provider value={{hoverTarget, setHoverTarget}}>
      {children}
    </HoverContext.Provider>
  )
}


function useHoverContext(){
  const context = useContext(HoverContext);
  
  if(context === undefined){
    throw new Error("useHoverContext must be used within a HoverContext.Provider")
  }
  
  return context;
}


export { HoverProvider, useHoverContext }